module.exports = __webpack_public_path__ + "img/header-diamondJewelryBracelets@2x.d195d0a.webp";